import React from 'react';
import './styles.css'
import {
    Layout,
    Input,
    Button,
    Card,
    Typography,
    Spin,
    Steps
} from "antd";

import { useQuery } from 'react-query';
import { UserRegistrationUpdate } from '../profile/api';
import { ClockCircleOutlined } from "@ant-design/icons";
import { useNavigator } from "../../utilities/navigation";
import { useEffect } from 'react';
import { useState } from 'react';
const UserVerification = () => {
    const [navigator] = useNavigator()
    const { Content } = Layout;
    const { Title, Text, Link } = Typography;
    const { Step } = Steps
    const [objection, setObjection] = useState([])
    const [resize,setResize] = useState(document?.documentElement?.clientWidth)

    useEffect(() => {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"))
        if (loggedUser == null) {
            navigator('/login')
        }
        else {
            refetch()
        }
    }, [])

    window.addEventListener("resize", ()=>{

            // alert(document?.documentElement?.clientWidth)
            setResize(document?.documentElement?.clientWidth)
    });

    const ongetSuccess = (data) => {
        const objection = data?.data?.company?.objections
        setObjection(objection)
        console.log(data)
    }

    const { isLoading, refetch } = useQuery('datapoint', async () => {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"))
        return await UserRegistrationUpdate.fetchUserData(loggedUser?.jwtToken)
    }, {
        enabled: false,
        onSuccess: ongetSuccess,
        onError: (err) => {

        },
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60

    })
    return (
        <>
            <Layout className="layout">
                <Content
                    style={{ padding: "0 14px" }}
                    className="Registration-content"
                >
                    <div className="site-layout-content1">
                        <Steps current={1} size='small' direction={resize < 700 ? 'horizontal':'horizontal'}>
                            <Step title="Application submitted" description="on 14-Dec-2022" />
                            <Step title="In progress..." />

                        </Steps>
                        <div className='verfication-content'
                        >
                            <ClockCircleOutlined className="waitclock" />
                            <Title level={3} className="profileUnderReview arrovedText">Registration request is under review!</Title>
                            <Text className = "arrovedText">Sehahub team is working on your application.</Text>
                            <Text className='arrovedText'>You will be notified via email once your account is approved.</Text>
                            <Text>Thanks for your patience</Text>
                        </div>
                        {objection?.length > 0 ?<Title level={4} className="objectionTitle">Your Profile Objection</Title>:null}

                        {
                            isLoading == false  ? <div className='objection'>
                                {
                                    objection?.map(item => {
                                        return <div className='objection-container'> <Title level={5}>{item?.key} : </Title> <Text type='danger'>{" " + item?.comment}</Text> </div>
                                    })
                                }
                                {objection?.length > 0 ? <Button type='primary' onClick={() => {
                                    navigator('/profile/edit')
                                }}>Edit your Profile</Button> : null}

                            </div> : <Spin></Spin>
                        }
                    </div>
                </Content>
            </Layout>
        </>

    )
}
export default UserVerification